/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Tenant selection request containing list of tenant IDs to aggregate
 * @export
 * @interface UpdateTenantSelectionRequest
 */
export interface UpdateTenantSelectionRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdateTenantSelectionRequest
     */
    selectedTenantIds?: Array<string>;
}

/**
 * Check if a given object implements the UpdateTenantSelectionRequest interface.
 */
export function instanceOfUpdateTenantSelectionRequest(value: object): value is UpdateTenantSelectionRequest {
    return true;
}

export function UpdateTenantSelectionRequestFromJSON(json: any): UpdateTenantSelectionRequest {
    return UpdateTenantSelectionRequestFromJSONTyped(json, false);
}

export function UpdateTenantSelectionRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateTenantSelectionRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'selectedTenantIds': json['selected_tenant_ids'] == null ? undefined : json['selected_tenant_ids'],
    };
}

export function UpdateTenantSelectionRequestToJSON(json: any): UpdateTenantSelectionRequest {
    return UpdateTenantSelectionRequestToJSONTyped(json, false);
}

export function UpdateTenantSelectionRequestToJSONTyped(value?: UpdateTenantSelectionRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'selected_tenant_ids': value['selectedTenantIds'],
    };
}

